import { Base, base } from "./base"


export type Fonts = Base

export const fonts: Fonts = {
  ...base
}    
